var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ads-container"},[_c('div',{staticClass:"ads-title"},[_vm._v("Advertisement")]),_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":"ca-pub-8605814769064371","data-ad-slot":_vm.adSlot,"data-ad-channel":_vm.adChannel,"data-ad-format":"auto","data-full-width-responsive":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }